// react core
import ReactMarkdown from 'react-markdown';
import React, { useState } from 'react';
import TimeAgo from 'react-timeago'
import { NotificationManager } from 'react-notifications';

// components
import AjaxSpinner from 'components/commons/ajax_spinner';
import VoteButtonsWithState from 'components/answers/vote_buttons_state';
import InlineComment from 'components/answers/inline_comment';
import AuthorLink from 'components/commons/author_link';

// utils
import { clone_object } from 'commons/utils';
import { approve_question_by_id, remove_approve_question_by_id } from 'commons/api';

// conf
import conf from 'conf/ajax';

export default function InlinePost(props)
{
    const item = props.item;
    const type = props.type;
    const classess = `${type}-view`;
    const [show_comment_form, set_show_comment_form] = useState(false);
    const [show_cmt_btn, set_show_cmt_btn] = useState(type === 'answer');
    const [posting_data, set_posting_data] = useState(false);

    const handle_btn_click = (evt) =>
    {
        set_show_comment_form(true);
        set_show_cmt_btn(false);
    };

    const handle_sub_on_cancel = (evt) =>
    {
        set_show_comment_form(false);
        set_show_cmt_btn(true);
    };

    const handle_sub_on_post = (evt, data) =>
    {
        let data_obj = clone_object(conf.ajax_configuration_object);
        data_obj.method = 'POST';
        data_obj.body = JSON.stringify(data);
        set_posting_data(true);
        fetch(conf.endpoints.insertpost, data_obj).then(function(response)
        {
            return response.json();
        })
        .then(function(data)
        {
            if(data.status === 'ok')
            {
                console.log('ok');
                console.log(data);
                set_show_comment_form(false);
                set_show_cmt_btn(true);
                set_posting_data(false);
                props.on_comment_post(data);
            }
        }).catch(error => console.error('Error:', error));
    };

    const handle_remove_button = (evt) =>
    {
        let data_obj = clone_object(conf.ajax_configuration_object);
        data_obj.method = 'DELETE';
        fetch(conf.endpoints.main + conf.server.main_folder + item.path, data_obj ).then(function(response)
        {
            console.log(response.ok);
            console.log(response.status);
            if (response.ok !== true)
            {
                throw new Error('Network response was not OK');
            }
        })
        .then(function(data)
        {
            NotificationManager.success('Your content will be removed', 'Ok!');
            props.on_comment_post(data);
        })
        .catch(function(error) {
            console.log("error is => " + error);
            NotificationManager.error('There was an errow while removing your content', 'Sorry');
        });
    }

    const handle_approve_button = (evt) =>
    {
        const fetchData = async () =>
        {
            const response =  await approve_question_by_id(item.path);
            const data = await response.json();
            if(data.status === 'ok')
            {
                console.log('ok, approved');
                props.on_approve_post();
            }
        }
        fetchData().catch(console.error);
    }

    const handle_disapprove_button = (evt) =>
    {
        const fetchData = async () =>
        {
            const response =  await remove_approve_question_by_id(item.path);
            const data = await response.json();
            if(data.status === 'ok')
            {
                console.log('ok, disapproved');
                props.on_approve_post();
            }
        }
        fetchData().catch(console.error);
    }

    return (
        <div className={classess}>
            <div>
                {item.approved &&
                <div className={type + '-view-header'}>
                    <div className={type + '-award'}><i className="fa-solid fa-award"></i> This answer was approved</div>
                </div>
                }
                <div className={type + '-view-body'}>
                    <ReactMarkdown components={{h1: 'h3', h2: 'h4'}}>{item.text}</ReactMarkdown>

                    {item.attachments && item.attachments.length > 0 &&
                        <div className="attachments-wrapper">
                            <label>Attachments:</label>
                            <ul>
                            {item.attachments.map(attachment => (
                                <li key={attachment.id}><i className="fa-solid fa-download"></i> <a href={attachment.url} title={`Download: ${attachment.filename} (${attachment.size})`}>{attachment.title}</a> <span></span></li>
                            ))}
                            </ul>
                        </div>
                        }


                </div>
                <div className={type + '-view-footer'}>
                    <div>
                        {type == 'answer' && <>Answered by</>} <AuthorLink author={item.author} /> <TimeAgo date={item.added_at} minPeriod="60" />
                    </div>
                    <div>


                    {item.can_delete &&
                            <button onClick={handle_remove_button} className="button button-small button-discreet"><i className="fa-solid fa-trash"></i> Remove your {type === 'comment' ? 'Comment' : 'Answer'}</button>
                    }
                    {item.can_approve &&
                            <button onClick={handle_approve_button} className="button button-small button-discreet"><i className="fa-solid fa-award"></i> Approve {type === 'comment' ? 'Comment' : 'Answer'}</button>
                    }
                    {item.can_disapprove &&
                        <button onClick={handle_disapprove_button} className="button button-small button-discreet"><i className="fa-solid fa-award"></i> Disapprove {type === 'comment' ? 'Comment' : 'Answer'}</button>
                    }
                    {show_cmt_btn &&
                        item.can_comment &&
                        <button onClick={handle_btn_click} className='button button-small button-primary'>
                            <i className="fa-solid fa-comment"></i> Add a Comment for this Answer
                        </button>
                    }
                    </div>


                </div>
                {show_comment_form && !posting_data && <InlineComment
                        parent_id={item.id}
                        parent_type="answer"
                        on_cacnel={handle_sub_on_cancel}
                        on_post={handle_sub_on_post}
                        can_comment={item.can_comment}
                    />}
                {show_comment_form && posting_data && <AjaxSpinner />}

            </div>
            {props.showshow_vote &&
            <div>
                <VoteButtonsWithState
                    id={item.id}
                    type="answer"
                    can_vote={item.can_vote}
                />
            </div>
            }

        </div>
    );
};